import { ReduxHelper } from "helpers";

export const prefix = "SIGNALR";

export const initInstance = ReduxHelper.generateLocalAction<string>(
  prefix,
  `INIT_INSTANCE`
);
